import { CardProps } from "@/src/common/types"
import React from "react"

const Card: React.FC<CardProps> = ({
  onClose,
  className,
  children,
  onApply,
  showCard
}) => {
  if (!showCard) return null

  return (
    showCard && (
      <div
        className={`min-w-[404px] z-40 border-[0.5px] dark:border-[#4B5563] dark:bg-[#1A1D21] bg-stears_white shadow-lg ${className}`}
      >
        <div className="py-2">{children}</div>
        <div className="border-t dark:border-gray-700 bg-[#1A1D21] flex justify-end items-center py-2.5 px-5 text-xs">
          <button
            onClick={onClose}
            className="mr-2 px-[10px] py-2 text-white border-[0.5px] dark:border-[#4B5563] bg-[#1A1D21]"
          >
            Cancel
          </button>
          <button
            className="px-[10px] py-2 bg-[#4B5563] text-white"
            onClick={onApply}
          >
            Apply
          </button>
        </div>
      </div>
    )
  )
}

export default Card
